import { jsxs, jsx } from "react/jsx-runtime";
const IconSpaceSharedSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.67 3.993a.73.73 0 0 1 .73.73V22.69a.73.73 0 0 1-1.46 0V4.723a.73.73 0 0 1 .73-.73Zm16.66 0a.73.73 0 0 1 .73.73V22.69a.73.73 0 0 1-1.46 0V4.723a.73.73 0 0 1 .73-.73Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "m11.832 0 10.432 4.711a.73.73 0 1 1-.6 1.33l-9.822-4.435-9.497 4.431a.73.73 0 0 1-.617-1.322L11.832 0ZM0 22.69a.73.73 0 0 1 .73-.73h22.54a.73.73 0 1 1 0 1.46H.73a.73.73 0 0 1-.73-.73Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M14.618 13.071h1.117l3.289 2.84v.963l-4.406-3.803Zm-4.107 0h1.117l7.396 6.385v.846a.363.363 0 0 1-.239-.088l-8.274-7.143Zm-3.422 0h1.117l9.687 8.363a.364.364 0 0 1 .127.276h-.924L7.09 13.071Zm-2.439.849v-.849h.133l10.008 8.64h-1.117L4.65 13.92Zm0 2.954v-.963l6.718 5.8h-1.116L4.65 16.873Zm0 2.955v-.964l3.296 2.845H6.829L4.65 19.83Zm14.374-6.499-.299-.259h.299v.258Z" })
    ]
  }
);
export {
  IconSpaceSharedSvg
};
